/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const interestDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	path: z.array(z.string()).nullable(),
})

export type InterestDataSchema = z.infer<typeof interestDataSchema>
